var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCo2 = function SvgCo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3072,
    cy: 12.1395,
    r: 11.5196,
    fill: "#F4F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1866 40.6291L37.247 43.5687L34.3074 40.6291",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2471 43.5688V35.636",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.826 42.6805L27.8864 45.6202L24.9468 42.6805",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8865 45.6201V37.6873",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4657 40.6291L18.5261 43.5687L15.5864 40.6291",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5261 43.5688V35.636",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7207 8.17799C44.6163 8.17799 46.1529 6.64135 46.1529 4.74582C46.1529 2.85029 44.6163 1.31366 42.7207 1.31366C40.8252 1.31366 39.2886 2.85029 39.2886 4.74582C39.2886 6.64135 40.8252 8.17799 42.7207 8.17799Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27909 38.9338C7.17462 38.9338 8.71125 37.3972 8.71125 35.5016C8.71125 33.6061 7.17462 32.0695 5.27909 32.0695C3.38356 32.0695 1.84692 33.6061 1.84692 35.5016C1.84692 37.3972 3.38356 38.9338 5.27909 38.9338Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3262 1.54337C21.0584 2.2961 24.029 5.82451 24.4403 7.93105",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3837 22.0555H8.32614C6.53695 22.0555 4.91715 21.3307 3.74487 20.1576C2.57258 18.9853 1.84692 17.3655 1.84692 15.5763C1.84692 12.3563 4.19595 9.68636 7.27331 9.18357C7.80997 9.0962 8.22094 8.66473 8.31187 8.12896C8.96978 4.25997 12.3378 1.31366 16.3948 1.31366C17.0449 1.31366 17.6773 1.38935 18.2837 1.53234",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6375 33.2434H38.0517C42.5259 33.2434 46.1531 29.6163 46.1531 25.142C46.1531 21.1161 43.216 17.7782 39.368 17.1495C38.6968 17.0398 38.1831 16.5007 38.0691 15.8301C37.2469 10.9924 33.0354 7.30899 27.9635 7.30899C22.8916 7.30899 18.6801 10.9924 17.8579 15.8301C17.7439 16.5006 17.2303 17.0398 16.559 17.1495C12.711 17.7782 9.77393 21.1162 9.77393 25.142C9.77393 29.6163 13.4011 33.2434 17.8753 33.2434H29.6375Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7145 20.4699C23.1557 20.0924 22.4821 19.872 21.757 19.872C19.8234 19.872 18.2559 21.4395 18.2559 23.3732C18.2559 25.3069 19.8233 26.8743 21.757 26.8743C22.5423 26.8743 23.1883 26.6158 23.6785 26.1792C23.7799 26.0889 23.8747 25.9909 23.9627 25.886",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.45 28.6238C38.45 28.6238 35.6949 28.6583 35.5644 28.6148C35.4339 28.5713 35.7736 28.3415 37.5799 25.7607C37.9172 25.2787 38.1029 24.8721 38.1819 24.5314L38.2099 24.3123C38.2099 23.5121 37.5612 22.8633 36.7609 22.8633C36.0567 22.8633 35.4699 23.3656 35.3391 24.0314",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 26.8739C31.4333 26.8739 33.0009 25.3064 33.0009 23.3727C33.0009 21.4391 31.4333 19.8716 29.4997 19.8716C27.5661 19.8716 25.9985 21.4391 25.9985 23.3727C25.9985 25.3064 27.5661 26.8739 29.4997 26.8739Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCo2;